import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServicioGeneral } from "../_services/servicio-general.service";
import { first, finalize } from "rxjs/operators";
import { UsuarioRecuperar } from "../model/usuariorecuperar";
import { NotificationI18nService } from '../core/util/notification-i18n.service';
import { Router } from '@angular/router';

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.css"],
})
export class ForgotPasswordComponent extends UnsubscribeOnDestroy implements OnInit {
  form: any = {
    email: null,
  };


  loading = false;
  isSuccessful = false;
  errorMessage = "";


  constructor(
    private formBuilder: UntypedFormBuilder,
    private serviciogeneral: ServicioGeneral,
    private _notificationI18n: NotificationI18nService,
    private _route: Router
  ) {
    super();
  }

  ngOnInit(): void {
    /*
    this.form = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
    */
  }

  onSubmit(): void {
    const { email } = this.form;
    this.loading = true;

    this.serviciogeneral.forgotPassword(email)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.isSuccessful = true;
        this._notificationI18n.success('NOTIFICATION.MESSAGE.HEMOS_ENVIADO_UN_EMAIL_CON_LAS_INSTRUCCIONES_PARA_CAMBIAR_LA_CONTRASENA', 5000);
        this._route.navigate(['/inicio']);
      },
      error: (err) => {
        this.loading = true;
        this._notificationI18n.errorDynamic(err.error.message, 5000);

      },
    });
  }
}
